import { useEffect, useState } from "react";
import { api, getRecentlyViewed } from "@/lib/api";
import ProductCard from "@/components/ProductCard";

export default function RecentlyViewed({ excludeSlug, title = "Recently viewed" }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const slugs = getRecentlyViewed().filter((s) => s !== excludeSlug);
    if (!slugs.length) { setItems([]); return; }
    api.get("/products").then((r) => {
      const bySlug = Object.fromEntries(r.data.map((p) => [p.slug, p]));
      setItems(slugs.map((s) => bySlug[s]).filter(Boolean).slice(0, 5));
    }).catch(() => {});
  }, [excludeSlug]);

  if (items.length === 0) return null;

  return (
    <section className="max-w-7xl mx-auto px-4 py-12 border-t border-border" data-testid="recently-viewed">
      <h2 className="text-xl font-display font-bold tracking-tight mb-6">{title}</h2>
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-4 lg:gap-6">
        {items.map((p, i) => <ProductCard key={p.slug} product={p} index={i} />)}
      </div>
    </section>
  );
}
